import { DropdownButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { CountrySelectCombobox } from "app/pages/sales-intelligence/common-components/dropdown/CountrySelectCombobox";
import { FormFieldLabel } from "app/pages/sales-intelligence/common-components/form-fields";
import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { StyledDDContainer } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppDownloadEngagementFilter/styles";
import {
    COUNTRY_LISTED_ADDRESS_FILTER_ID,
    COUNTRY_SELECT_WIDTH,
} from "app/pages/sales-intelligence/modules/find-apps-filters/constants";
import type { IAppListedAddressFilterDto } from "app/pages/sales-intelligence/store/find-apps/types";
import { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";
import type { ICountryObject } from "app/services/CountryService";

const ListedAddressFilter = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseModelProps<IAppListedAddressFilterDto, ICountryObject[]>) => {
    const renderDDButton = () => {
        return (
            <StyledBaseDropdownButtonWrap key="countries-dropdown-button">
                <DropdownButton>{translate("si.components.countries-dropdown.button.text")}</DropdownButton>
            </StyledBaseDropdownButtonWrap>
        );
    };

    const handleSelect = (country: ICountryObject) => {
        if (value?.countries.includes(country.id)) {
            const countries = value?.countries.filter((item: number) => item !== country.id);
            onFilterUpdate(countries.length > 0 ? { ...value, countries } : undefined);
        } else {
            onFilterUpdate({
                ...value,
                countries: value?.countries ? [...value?.countries, country.id] : [country.id],
            });
        }
    };

    return (
        <Flex
            flexDirection="column"
            maxWidth="263px"
            rowGap="16px"
        >
            <FormFieldLabel text={translate("si.common.countries")}>
                <StyledDDContainer
                    id={COUNTRY_LISTED_ADDRESS_FILTER_ID}
                    customWidth={COUNTRY_SELECT_WIDTH}
                >
                    <CountrySelectCombobox
                        multi
                        onSelect={handleSelect}
                        selectedIds={value?.countries || []}
                        items={filter.options}
                        renderButton={renderDDButton}
                        searchPlaceHolder={translate("si.find_apps.filters.listed-address.country.placeholder")}
                    />
                </StyledDDContainer>
            </FormFieldLabel>
        </Flex>
    );
};

export default ListedAddressFilter;
